<template>
  <v-dialog v-model="dialog" width="900" scrollable>
    <v-card flat>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer />
        <v-btn text icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-container>
        <base-table-header @search="onSearch" @reload="onReload">
          <template v-slot:subtitle>
            <div class="mt-4 subtitle-1 black--text"> {{ total }} {{ title.split(' ')[1] || '-' }} </div>
          </template>
        </base-table-header>
        <div style="height: 350px; overflow: scroll">
          <base-list-table :hideHeader="true" :loading="loading" :item="data" :total="total" :usePaging="false">
            <template slot-scope="{ item }">
              <td>
                <v-card :disabled="disabled.includes(+item.sekolah_id)" flat class="ma-0">
                  <v-list-item dense class="px-0">
                    <v-list-item-content>
                      <v-row>
                        <v-col v-for="(field, f) in fields" :key="f" class="py-0" v-bind="field.grid">
                          <v-list-item class="px-0">
                            <v-list-item-avatar v-if="field.icon" color="secondary">
                              <v-icon dark>{{ field.icon }}</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <div class="caption" v-html="field.title" />
                              <template v-if="field && field.list && field.list.length">
                                <div v-for="list in field.list" :key="list.key" :class="`${list.class}`">
                                  {{ $getDeepObj(list, 'label') }} {{ $getDeepObj(item, list.key) }}
                                </div>
                              </template>
                              <template v-else>
                                <div>{{ $getDeepObj(item, field.key) }}</div>
                              </template>
                            </v-list-item-content>
                            <v-list-item-action-text>
                              <v-btn
                                icon
                                :color="selectedItem.includes(+item.sekolah_id) ? 'success' : 'grey'"
                                @click="onSelectItem(item)"
                              >
                                <v-icon>
                                  {{
                                    selectedItem.includes(+item.sekolah_id)
                                      ? 'mdi-checkbox-marked'
                                      : 'mdi-checkbox-blank-outline'
                                  }}
                                </v-icon>
                              </v-btn>
                            </v-list-item-action-text>
                          </v-list-item>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </td>
            </template>
          </base-list-table>
        </div>
        <v-divider />
        <base-table-footer :pageTotal="pageTotal" @changePage="onChangePage" />
        <div class="text-right">
          <div>
            <span class="blue--text body-1">{{ selected.length || 0 }}</span> Sekolah Terpilih
          </div>
          <v-btn color="success" depressed @click="onSelect">Pilih Peserta</v-btn>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import list from '@mixins/list';
export default {
  mixins: [list],
  props: {
    api: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    disable: {
      type: String,
      default: null,
    },
    labelDisable: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      fields: [],
      selected: [],
      disabled: [],
    };
  },

  computed: {
    selectedItem() {
      return this.selected.map((item) => item.sekolah_id);
    },
  },

  methods: {
    fetchData() {
      const params = Object.assign(this.params, this.$isObject(this.filters) ? this.filters : {});
      this.$store.dispatch(this.api, { params: params, id: this.id }).then(({ data, meta }) => {
        this.data = data || [];
        this.total = meta?.total || 0;
        this.pageTotal = meta?.last_page || 1;
        this.params.limit = meta?.per_page || this.params.limit;
      });
    },

    open(fields, disabled) {
      this.dialog = true;
      this.fields = fields || [];
      this.data = [];
      this.selected = [];
      this.disabled = disabled || [];
      this.fetchData();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    onSelect() {
      this.resolve(this.selected);
      this.dialog = false;
    },

    onSelectItem(item) {
      const findIndex = this.selected.findIndex((s) => s.sekolah_id === item.sekolah_id);
      if (findIndex > -1) {
        this.selected.splice(findIndex, 1);
      } else {
        this.selected.push(item);
      }
    },
  },
};
</script>
